import React, { lazy } from 'react'
import { ApprovalPolicyAPPaymentForm } from '../GeneralApprovalPolicy/ApprovalPolicyAP/ApprovalPolicyAPPaymentForm'
import { ApprovalPolicyAPAdvanceForm } from '../GeneralApprovalPolicy/ApprovalPolicyAP/ApprovalPolicyAPAdvanceForm'

const ApprovalPolicySubmenu = lazy(() =>
  import('./ApprovalPolicySubmenu').then(module => ({
    default: module.ApprovalPolicySubmenu,
  }))
)

const ApprovalPolicyRoleForm = lazy(() =>
  import('./ApprovalPolicyRoleForm').then(module => ({
    default: module.ApprovalPolicyRoleForm,
  }))
)

const approvalPolicyRoutes = [
  //GENERAL LEDGER
  {
    props: {
      exact: true,
      path: '/general-ledger/general-setting/approval-policy-gl',
    },
    component: <ApprovalPolicySubmenu module="general-ledger" />,
  },
  {
    props: {
      exact: true,
      path: '/general-ledger/general-setting/approval-policy-gl/:docType',
    },
    component: <ApprovalPolicyRoleForm module="general-ledger" />,
  },

  // -- budget stuff
  {
    props: {
      exact: true,
      path:
        '/general-ledger/general-setting/approval-policy-gl/:docType/original',
    },
    component: (
      <ApprovalPolicyRoleForm module="general-ledger" budget="original" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-ledger/general-setting/approval-policy-gl/:docType/revision',
    },
    component: (
      <ApprovalPolicyRoleForm module="general-ledger" budget="revision" />
    ),
  },

  //CASH BOOK
  {
    props: {
      exact: true,
      path: '/cash-book/general-setting/approval-policy-cb',
    },
    component: <ApprovalPolicySubmenu module="cash-book" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-book/general-setting/approval-policy-cb/:docType',
    },
    component: <ApprovalPolicyRoleForm module="cash-book" />,
  },

  //AR
  {
    props: {
      exact: true,
      path: '/account-receivable/general-setting/approval-policy-ar',
    },
    component: <ApprovalPolicySubmenu module="account-receivable" />,
  },
  {
    props: {
      exact: true,
      path: '/account-receivable/general-setting/approval-policy-ar/:docType',
    },
    component: <ApprovalPolicyRoleForm module="account-receivable" />,
  },

  //AP
  {
    props: {
      exact: true,
      path: '/account-payable/general-setting/approval-policy',
    },
    component: <ApprovalPolicySubmenu module="account-payable" />,
  },

  //AP Payment Approval Policy
  {
    props: {
      exact: true,
      path: '/account-payable/general-setting/approval-policy/payment',
    },
    component: <ApprovalPolicyAPPaymentForm />,
  },

  //AP Advance Approval Policy
  {
    props: {
      exact: true,
      path: '/account-payable/general-setting/approval-policy/advance',
    },
    component: <ApprovalPolicyAPAdvanceForm />,
  },
]

export default approvalPolicyRoutes
